import { render, staticRenderFns } from "./genericWidgetTile.vue?vue&type=template&id=4712799c"
import script from "./genericWidgetTile.vue?vue&type=script&lang=js"
export * from "./genericWidgetTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports